module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editMyTender":"Edit Tender","showMyTender":"Show Tender"},"al":{"editMyTender":"Modifiko Tenderin","showMyTender":"Shiko Tenderin"}}')
  delete Component.options._Ctor
}
